// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   States — loading skeletons, empty, error
   ============================================ */

/* Loading: skeleton grid */
.grb-widget--loading {
  padding: 0;
}

.grb-widget--loading-grid {
  display: grid;
  grid-template-columns: repeat(var(--grb-grid-columns-desktop), 1fr);
  gap: var(--grb-grid-gap);
}

@media (max-width: 1024px) and (min-width: 769px) {
  .grb-widget--loading-grid {
    grid-template-columns: repeat(var(--grb-grid-columns-tablet), 1fr);
  }
}

@media (max-width: 768px) {
  .grb-widget--loading-grid {
    grid-template-columns: repeat(var(--grb-grid-columns-mobile), 1fr);
  }
}

.grb-widget--skeleton-card {
  display: flex;
  flex-direction: column;
}

.grb-widget--skeleton-image {
  width: 100%;
  padding-top: 133%;
  background: var(--grb-color-background-secondary);
  animation: grb-pulse 1.5s ease-in-out infinite;
}

.grb-widget--skeleton-line {
  height: 12px;
  margin: var(--grb-spacing-sm) var(--grb-spacing-sm) 0;
  background: var(--grb-color-background-secondary);
  animation: grb-pulse 1.5s ease-in-out infinite;
}

.grb-widget--skeleton-line.grb-widget--short,
.grb-widget--skeleton-line-short {
  width: 60%;
}

@keyframes grb-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

/* Empty state */
.grb-widget--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--grb-spacing-xl) var(--grb-spacing-md);
  text-align: center;
  min-height: 300px;
}

.grb-widget--empty-icon {
  width: 40px;
  height: 40px;
  margin-bottom: var(--grb-spacing-md);
  color: var(--grb-color-text-secondary);
}

.grb-widget--empty-icon svg {
  width: 100%;
  height: 100%;
  stroke: currentColor;
  fill: none;
}

.grb-widget--empty-title {
  font-size: var(--grb-font-size-lg);
  font-weight: 500;
  margin-bottom: var(--grb-spacing-xs);
}

.grb-widget--empty-text {
  font-size: var(--grb-font-size-base);
  color: var(--grb-color-text-secondary);
}

/* Error state */
.grb-widget--error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--grb-spacing-xl) var(--grb-spacing-md);
  text-align: center;
  min-height: 300px;
}

.grb-widget--error-icon {
  width: 40px;
  height: 40px;
  margin-bottom: var(--grb-spacing-md);
  color: var(--grb-color-error);
}

.grb-widget--error-icon svg {
  width: 100%;
  height: 100%;
  stroke: currentColor;
  fill: none;
}

.grb-widget--error-title {
  font-size: var(--grb-font-size-lg);
  font-weight: 500;
  margin-bottom: var(--grb-spacing-xs);
}

.grb-widget--error-text {
  font-size: var(--grb-font-size-base);
  color: var(--grb-color-text-secondary);
  margin-bottom: var(--grb-spacing-md);
}

.grb-widget .grb-widget--retry-btn {
  display: inline-flex;
  align-items: center;
  height: 40px;
  padding: 0 var(--grb-spacing-lg);
  background: var(--grb-color-primary);
  color: #fff;
  font-size: var(--grb-font-size-sm);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  transition: background-color 0.15s ease;
}

.grb-widget .grb-widget--retry-btn:hover {
  background: var(--grb-color-primary-hover);
}
`, "",{"version":3,"sources":["webpack://./src/styles/states.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kEAAkE;EACpE;AACF;;AAEA;EACE;IACE,kEAAkE;EACpE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,WAAW;EACX,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["/* ============================================\n   States — loading skeletons, empty, error\n   ============================================ */\n\n/* Loading: skeleton grid */\n.grb-widget--loading {\n  padding: 0;\n}\n\n.grb-widget--loading-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--grb-grid-columns-desktop), 1fr);\n  gap: var(--grb-grid-gap);\n}\n\n@media (max-width: 1024px) and (min-width: 769px) {\n  .grb-widget--loading-grid {\n    grid-template-columns: repeat(var(--grb-grid-columns-tablet), 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .grb-widget--loading-grid {\n    grid-template-columns: repeat(var(--grb-grid-columns-mobile), 1fr);\n  }\n}\n\n.grb-widget--skeleton-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.grb-widget--skeleton-image {\n  width: 100%;\n  padding-top: 133%;\n  background: var(--grb-color-background-secondary);\n  animation: grb-pulse 1.5s ease-in-out infinite;\n}\n\n.grb-widget--skeleton-line {\n  height: 12px;\n  margin: var(--grb-spacing-sm) var(--grb-spacing-sm) 0;\n  background: var(--grb-color-background-secondary);\n  animation: grb-pulse 1.5s ease-in-out infinite;\n}\n\n.grb-widget--skeleton-line.grb-widget--short,\n.grb-widget--skeleton-line-short {\n  width: 60%;\n}\n\n@keyframes grb-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n/* Empty state */\n.grb-widget--empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--grb-spacing-xl) var(--grb-spacing-md);\n  text-align: center;\n  min-height: 300px;\n}\n\n.grb-widget--empty-icon {\n  width: 40px;\n  height: 40px;\n  margin-bottom: var(--grb-spacing-md);\n  color: var(--grb-color-text-secondary);\n}\n\n.grb-widget--empty-icon svg {\n  width: 100%;\n  height: 100%;\n  stroke: currentColor;\n  fill: none;\n}\n\n.grb-widget--empty-title {\n  font-size: var(--grb-font-size-lg);\n  font-weight: 500;\n  margin-bottom: var(--grb-spacing-xs);\n}\n\n.grb-widget--empty-text {\n  font-size: var(--grb-font-size-base);\n  color: var(--grb-color-text-secondary);\n}\n\n/* Error state */\n.grb-widget--error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--grb-spacing-xl) var(--grb-spacing-md);\n  text-align: center;\n  min-height: 300px;\n}\n\n.grb-widget--error-icon {\n  width: 40px;\n  height: 40px;\n  margin-bottom: var(--grb-spacing-md);\n  color: var(--grb-color-error);\n}\n\n.grb-widget--error-icon svg {\n  width: 100%;\n  height: 100%;\n  stroke: currentColor;\n  fill: none;\n}\n\n.grb-widget--error-title {\n  font-size: var(--grb-font-size-lg);\n  font-weight: 500;\n  margin-bottom: var(--grb-spacing-xs);\n}\n\n.grb-widget--error-text {\n  font-size: var(--grb-font-size-base);\n  color: var(--grb-color-text-secondary);\n  margin-bottom: var(--grb-spacing-md);\n}\n\n.grb-widget .grb-widget--retry-btn {\n  display: inline-flex;\n  align-items: center;\n  height: 40px;\n  padding: 0 var(--grb-spacing-lg);\n  background: var(--grb-color-primary);\n  color: #fff;\n  font-size: var(--grb-font-size-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  transition: background-color 0.15s ease;\n}\n\n.grb-widget .grb-widget--retry-btn:hover {\n  background: var(--grb-color-primary-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
